import React from "react";
import { Modal3 } from "../../../../components/DIsplay/Modal/Modal3";
import ChangeBankTransferProofCard from "./ChangeBankTransferProofCard";

export default function ChangeBankTransferProofModal({
  open,
  setOpen,
  data,
  onUpdated,
}) {
  return (
    <Modal3
      open={Boolean(open)}
      setOpen={(next) => {
        if (!next) setOpen?.(false);
      }}
      title="Bank payment proof"
    >
      <div className="p-4 max-w-[560px] min-w-[320px] max-h-[75vh] overflow-y-auto">
        {data ? (
          <ChangeBankTransferProofCard
            data={typeof data === "object" ? data : null}
            showHistory
            embedded
            onUpdated={(next) => {
              onUpdated?.(next);
              if (
                !Array.isArray(next?.bankTransferProofs) ||
                !next.bankTransferProofs.some(
                  (p) => String(p?.status || "").toLowerCase() === "pending",
                )
              ) {
                setOpen?.(false);
              }
            }}
          />
        ) : (
          <p className="text-sm text-gray-500">No change request loaded.</p>
        )}
      </div>
    </Modal3>
  );
}
